import _ar from "./ar.json"
import _en from "./en.json"

 const  _t = (value) => {
    let lang = window.localStorage.getItem('lang');
  return  lang === "ar" ? _ar[value] : _en[value]
 }


 export default _t ;